export enum RejectionReason {
  TextTooHigh,
  TextTooWide,
  TextTooSmall,
  CharacterWontFit,
  FontSizeTooLarge,
  FontSizeTooSmall,
  FontFamilyTooLarge,
  InvalidCharacters,
  Unspecified,
}

export interface RejectionOptions {
  flexible: boolean;
  zoomMode: string;
}

export function getRejectionMessage(
    reason: RejectionReason,
    options: RejectionOptions = {
      flexible: false,
      zoomMode: 'fit'
    }): string | undefined
{
  switch (reason) {
    case RejectionReason.TextTooHigh:
      if (options.flexible) {
        return 'i18n.control.textEditing.rejectMessage.resizeTextField';
      }
      return 'i18n.control.textEditing.rejectMessage.maxLinesReached';
    case RejectionReason.TextTooWide:
      if (options.flexible && options.zoomMode === 'fit') {
        return 'i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField'; // tslint:disable-line
      }
      else if (options.zoomMode === 'limit') {
        return 'i18n.control.textEditing.rejectMessage.maxCharactersReached';
      }
      return 'i18n.control.textEditing.rejectMessage.insertLineBreak';
    case RejectionReason.CharacterWontFit:
      return 'i18n.control.textEditing.rejectMessage.characterWontFit';
    case RejectionReason.FontFamilyTooLarge:
      return 'i18n.control.textEditing.rejectMessage.fontFamilyTooLarge';
    case RejectionReason.FontSizeTooLarge:
      return 'i18n.control.textEditing.rejectMessage.fontSizeTooLarge';
    case RejectionReason.FontSizeTooSmall:
      return 'i18n.control.textEditing.rejectMessage.fontSizeTooSmall';
    case RejectionReason.InvalidCharacters:
      return 'i18n.control.textEditing.rejectMessage.invalidCharacters';

    default: return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/controls/text-editing/text-editing.messages.ts